import { ComponentType, createElement, lazy, Suspense } from 'react';

type Loader<P> = () => Promise<{ default: ComponentType<P> } | ComponentType<P>>;

type DynamicOptions = {
  ssr?: boolean;
  loading?: ComponentType<any>;
} & Partial<Record<string, unknown>>;

const dynamic = <P extends object>(loader: Loader<P>, options?: DynamicOptions): ComponentType<P> => {
  const LazyComponent = lazy(async () => {
    const mod = await loader();
    return 'default' in mod ? mod : { default: mod };
  });

  const Loading = options?.loading;

  return (props: P) => (
    <Suspense fallback={Loading ? <Loading /> : null}>{createElement(LazyComponent, props)}</Suspense>
  );
};

export default dynamic;
